import { getRouteIdFromPathname } from './getRouteIdFromPathname';
import type { RouterState } from './routerState';
import type { RouteIdType, Routes } from './routes';
import { routes } from './routes';

export function getRouteFromPathname<T extends RouteIdType>(
  pathname: string,
): Pick<RouterState<T>, 'id' | 'params'> {
  const routeId = getRouteIdFromPathname(pathname);
  const route = routes[routeId];

  return {
    id: routeId,
    params: route.getRouteParams(pathname) as ReturnType<
      Routes[T]['getRouteParams']
    >,
  };
}
